import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import TablePaginationActions from "../../../../../../globals/components/TablePaginationActions";
import { CarrierTabEmptyRow, CarrierTabLoadingRow } from "./carrierTabTablePrimitives";

export default function CarrierBondsTabPanel({ vm }) {
  const {
    handleOpenBondDialog,
    rowsPerPageBonds,
    handleEditBondClick,
    handleDeleteBond,
    bondsLoading,
    handleChangePageBonds,
    handleChangeRowsPerPageBonds,
    paginationSx,
    bonds,
    headerRowSx,
    pageBonds,
    tableCardSx,
  } = vm;

  const renderBody = () => {
    if (bondsLoading) {
      return <CarrierTabLoadingRow colSpan={4} />;
    }
    if (bonds.length === 0) {
      return <CarrierTabEmptyRow colSpan={4} message="No bonds found" />;
    }
    const slice = bonds.slice(
      pageBonds * rowsPerPageBonds,
      pageBonds * rowsPerPageBonds + rowsPerPageBonds,
    );
    return slice.map((bond) => (
      <TableRow key={bond.bond_code_id}>
        <TableCell>{bond.bond_type.type}</TableCell>
        <TableCell align="right">{bond.total || 0}</TableCell>
        <TableCell align="right">{bond.code}</TableCell>
        <TableCell align="center">
          <IconButton color="primary" onClick={() => handleEditBondClick(bond)}>
            <EditIcon />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteBond(bond.bond_code_id)}>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
        <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleOpenBondDialog}>
          Add Bond
        </Button>
      </Box>
      <TableContainer component={Paper} sx={tableCardSx}>
        <Table>
          <TableHead>
            <TableRow sx={headerRowSx}>
              <TableCell>Bond Name</TableCell>
              <TableCell align="right">Running Total</TableCell>
              <TableCell align="right">Bond Code</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderBody()}</TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        ActionsComponent={TablePaginationActions}
        component="div"
        count={bonds.length}
        page={pageBonds}
        onPageChange={handleChangePageBonds}
        rowsPerPage={rowsPerPageBonds}
        onRowsPerPageChange={handleChangeRowsPerPageBonds}
        rowsPerPageOptions={[5, 10, 25, 50]}
        sx={paginationSx}
      />
    </>
  );
}

CarrierBondsTabPanel.propTypes = {
  vm: PropTypes.object.isRequired,
};
